module.exports = __webpack_public_path__ + "static/media/5-iveco-mercedes.9bf84690.jpg";